<template>
  <el-dialog
    title=""
    :visible.sync="state"
    width="60%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <!-- <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form> -->
    <el-form
      :model="formData"
      :rules="rules"
      label-width="110px"
      ref="formData"
    >
      <p style="text-align: center; margin-bottom: 10px; color: #409eff">
        注：每条大事件之间用‘&&’隔开
      </p>
      <el-form-item label="年份" prop="title" required>
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="大事件" prop="content" required>
        <el-input v-model="formData.content" type="textarea"></el-input>
      </el-form-item>
      <!-- <el-form-item label="大事件" required v-if="!formData.ispushMp">
        <MyEditor ref="editor" v-model="formData.content" />
      </el-form-item> -->
      <div class="button-group" style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 185px; margin: 0 20px"
          class="form-button"
          @click="submitFn"
        >
          <span>更新</span>
        </el-button>
      </div>
    </el-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
// import { uploadFile } from '@/api/training'
// import MyEditor from './MyEditor.vue'
export default {
  // components: { MyEditor },
  props: {
    state: {
      type: Boolean,
      default: false
    },
    row: Object,
    roles: Array
  },
  watch: {
    // row(newData) {
    //   console.log("watch", newData);
    // },
    row: {
      handler(newData) {
        console.log(newData)
        if (!newData) return
        let that = this
        // console.log("watch", newData);
        that.formData = newData
        // that.$nextTick(() => {
        // that.$refs.editor.html = newData.content
        // })
      },
      immediate: true
    }
  },
  data() {
    return {
      fileList: [],
      formData: {
        // title: '',
        // content: '',
        // status: 1,
        // thumbnail: ''
      },

      rules: {
        time: [{ required: true, message: '年份必填', trigger: 'blur' }],
        content: [{ required: true, message: '事件必填', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 判断富文本编辑器输入是否为空或回车
    getText(str) {
      return str
        .replace(/<[^<p>]+>/g, '') // 将所有<p>标签 replace ''
        .replace(/<[</p>$]+>/g, '') // 将所有</p>标签 replace ''
        .replace(/&nbsp;/gi, '') // 将所有 空格 replace ''
        .replace(/<[^<br/>]+>/g, '') // 将所有 换行符 replace ''
    },
    isNull(str) {
      if (str == '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn() {
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          this.$emit('confirm', this.formData)
        }
      })
      console.log('更新数据处理', this.formData)
    }
  },
  mounted() {
    // this.$nextTick(() => {
    // this.$refs.editor.html = this.formData.content
    // })
  }
}
</script>

<style></style>
